import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store';
import { Button, OptionCard, OptionCardContent, ProgressBar } from '../../components/ui';
import type { AgeRange } from '../../types';

const AGE_OPTIONS: { value: AgeRange; label: string }[] = [
  { value: '18-24', label: '18-24' },
  { value: '25-34', label: '25-34' },
  { value: '35-44', label: '35-44' },
  { value: '45+', label: '45+' },
];

export function AgeScreen() {
  const navigate = useNavigate();
  const { onboarding, updateOnboarding, nextStep } = useStore();

  const handleSelect = (ageRange: AgeRange) => {
    updateOnboarding({ ageRange });
  };

  const handleContinue = () => {
    if (onboarding.ageRange) {
      nextStep();
      navigate('/onboarding/focus');
    }
  };

  return (
    <div className="screen-container onboarding-screen">
      <ProgressBar current={3} total={17} className="mb-8" />

      <div className="flex-1 flex flex-col">
        <h1 className="text-3xl font-bold mb-2">What's your age range?</h1>
        <p className="text-secondary mb-8">
          Different ages have different optimization paths.
        </p>

        <div className="space-y-3 mb-8">
          {AGE_OPTIONS.map(({ value, label }) => (
            <OptionCard
              key={value}
              selected={onboarding.ageRange === value}
              onClick={() => handleSelect(value)}
            >
              <OptionCardContent title={label} />
            </OptionCard>
          ))}
        </div>
      </div>

      <Button
        onClick={handleContinue}
        disabled={!onboarding.ageRange}
      >
        Continue
      </Button>
    </div>
  );
}
